<template>
  <el-row class="navbar" type="flex" justify="space-between" :gutter="24">
    <!-- <hamburger
      :toggle-click="toggleSideBar"
      :is-active="sidebar.opened"
      class="hamburger-container"
    /> -->

    <!-- <breadcrumb class="breadcrumb-container" /> -->
    <el-col :md="18" :sm="12" :xs="12">
      <new-tags-view class="tags-container" />
    </el-col>

    <el-col :md="6" :sm="12" :xs="12">
      <div class="right-menu avatar-container">
        <!-- <el-dropdown class=" right-menu-item" trigger="click">
        
      </el-dropdown> -->
        <div class="avatar-wrapper">
          <!--          <router-link to="/index" class="icon__web" title="点击进入官网">-->
          <!--            <i class="el-icon-reading"></i>-->
          <!--          </router-link>-->

          <img src="@/static/img/profile_small.jpg" alt="" class="avatar" />
          <span class="user-avatar">{{ userInfo.nick }}</span>
          <span class="iconfont iconLogout" @click="logout"></span>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import { mapGetters } from "vuex";
// import Breadcrumb from "@/components/Breadcrumb";
import NewTagsView from "./NewTagsView.vue";
import { getUserInfo } from "@/utils/user";
// import Hamburger from "@/components/Hamburger";

export default {
  components: {
    NewTagsView,
  },
  data() {
    return {
      userInfo: {},
    };
  },
  async mounted() {
    const userInfo = getUserInfo();
    if (userInfo) {
      this.userInfo = userInfo;
    } else {
      await this.$store.dispatch("getUserInfo").then((res) => {
        this.userInfo = res;
      });
    }
  },
  computed: {
    ...mapGetters(["sidebar", "user", "device"]),
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch("toggleSideBar");
    },
    logout() {
      this.$store.dispatch("logOut").then(() => {
        location.reload();
      });
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 64px;
  overflow: hidden;
  display: flex;
  padding: 0 24px;
  border-bottom: 1px solid #efefef;

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 64px;
    min-width: 180px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      cursor: pointer;
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 20px;
      color: #5a5e66;
      vertical-align: text-bottom;
      transition: background 0.3s;
      &:hover {
        background: rgba(0, 0, 0, 0.025);
      }
    }

    .avatar-wrapper {
      // margin-top: 5px;
      position: relative;
      display: flex;
      align-items: center;
      padding: 0 20px;
      /*width:360px;*/
      justify-content: flex-end;
      .icon__web {
        margin-right: 10px;
        color: #8a9199;
        display: flex;
        cursor: pointer;
        i {
          font-size: 24px;
        }
      }
      .avatar {
        width: 24px;
        height: 24px;
        border-radius: 50%;
        margin: 0 5px;
      }
      .user-avatar {
        cursor: pointer;
        font-size: 20px;
        margin: 0 10px;
        color: #17181a;
      }
      @media only screen and (max-width: 1200px) {
        .user-avatar {
          font-size: 16px;
        }
      }
      .iconLogout {
        color: #8a9199;
        cursor: pointer;
      }
      .el-icon-caret-bottom {
        cursor: pointer;
        position: absolute;
        right: -20px;
        top: 19px;
        font-size: 12px;
      }
    }
  }
}
</style>
